import type { LocaleMessages } from '../types';

export const zh: LocaleMessages = {
  app: {
    brand: 'ACEX · 智能体资本交易所',
    title: 'Pulse Terminal',
  },
  locale: {
    label: '语言',
  },
  header: {
    chain: '链',
    refresh: '刷新 {ms}ms',
    chainFilterUniOnly: '链筛选仅在 LIVE 模式下生效',
  },
  contour: {
    live: 'LIVE',
    uni: 'UNI',
    liveBadge: 'LIVE · {mode}',
    uniBadge: 'UNI · {phase}',
  },
  dataSource: {
    live: {
      label: 'LIVE · Factory / Hub',
      formula:
        '产品能力（hub 目录）→ 每个 listing 的 ACEX v0.2 平均值；按 capabilities 进行链筛选',
    },
    uni: {
      label: 'UNI · Alien Monitor',
      formula:
        '图指标 → $/call 代理值 → ACEX v0.2（NAV = $/call × success × trust × 100；index = $/call × success × 1000）',
    },
  },
  dataSourceBar: {
    loading: '加载中…',
  },
  error: {
    uniHint: '请启动 Alien Monitor（/monitor/，UNI 模式）',
    liveHint: '需要 API 位于 /api/v2/capital/pricing（factory :9081）',
  },
  panel: {
    agentListings: '智能体挂牌',
    agentListingsSub: 'CapShares · 实时 NAV',
    universeListings: '宇宙节点',
    universeListingsSub: 'UNI 轮廓 · Alien Monitor 图',
    agentListing: '智能体挂牌',
    selectRow: '选择一行',
    selectHint:
      '选择一个挂牌以查看 CapShare NAV、指数组成和 CapSense 系列。',
    listingFallback: '挂牌',
  },
  listings: {
    emptyLive: '暂无挂牌 — 请启动 factory 流水线或带 capabilities 的 hub',
    emptyUni: '暂无宇宙节点 — 请启动 Alien Monitor（UNI 模式）',
    caps: '{count} caps',
    capabilities: '{count} capabilities',
    capShareNav: 'CapShare NAV',
    trust: 'trust {pct}%',
    idx: 'idx {value}',
    details: '详情 →',
    colListing: '挂牌',
    colCapShare: 'CapShare',
    colIndex: '指数',
    colIv: 'IV',
    colTrust: 'Trust',
    colAudit: '审计',
    colRoute: '路由',
    colTrend: '趋势',
    iv: 'IV {pct}%',
    uncovered: '无覆盖',
    watch: 'watch',
  },
  detail: {
    uniSubtitle: 'UNI · 来自监视器图的 NAV（ACEX v0.2）',
    liveSubtitle: 'LIVE · 来自产品 capabilities 的 CapShare',
    capShareNav: 'CapShare NAV',
    indexLevel: '指数水平',
    iv: 'IV',
    pricePerCall: '$/call',
    success30d: 'Success 30d',
    trustScore: 'Trust score',
    reliability: '可靠性',
    indexComponents: '指数组成',
    change24h: '24h {value}',
    capsenseTitle: 'CapSense Options',
    capsenseSub: '第 2 阶段 · Solana',
    openSeries: '开放系列',
    capsenseHint: 'revenue index 上的 Calls · 到期 {days}天',
    liquidityTitle: 'Liquidity mesh',
    liquiditySub: '路由',
    poaTitle: 'Proof-of-Audit',
    poaSub: '质押审计员的覆盖 · invoke 费用分成',
    insured: '已投保',
    noCover: '无覆盖',
    aggregateScore: '综合 score',
    totalCover: '总覆盖',
    auditors: '审计员',
    auditFee: 'Audit fee',
    accruedRewards: '累计 rewards',
    noteSpread: 'Note spread',
    baseline: 'Baseline {value}',
    twap: 'TWAP {value}',
    drawdown: '回撤 {pct}%',
    coverLine: 'cover {value}',
    scoreLine: 'score {pct}%',
    pendingLine: 'pending {value}',
  },
  defaultRisk: {
    none: '违约风险：低',
    watch: '违约风险：watch',
    elevated: '违约风险：elevated',
    defaulted: '违约风险：defaulted',
  },
  statusBar: {
    acex: 'ACEX {version}',
    listings: '{count} listings',
    latency: '{ms}ms',
    navSum: 'Σ NAV {value}',
    version: 'Pulse v0.1',
  },
  mobile: {
    close: '关闭',
  },
  ticker: {
    uni: 'uni',
  },
};
